import React, { useContext, useState } from "react";
import { useQuery } from "react-query";
import { QK } from "../../../base/qk";
import { getWeightsChart } from "../../../api/services/notification";
import { formatDateTime } from "../../../base/FormatTime";
import TableComponent from "../../TableComponent/TableComponent";
import MyContext from "../../../context/MyContext";

const WeightsContent = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { locationID } = useContext(MyContext);

  const weightsPerPage = 10;

  const { data: weights, isLoading } = useQuery(
    [QK.weightLists, currentPage, locationID],
    () => getWeightsChart(currentPage, locationID),
    { keepPreviousData: true, enabled: !!currentPage || !!locationID }
  );

  const totalRecords = weights?.count || 0;
  const totalPages = Math.ceil(totalRecords / weightsPerPage);

  const handlePageChange = (event, page) => setCurrentPage(page);

  const columns = [
    {
      field: "client_name",
      headerName: "Client Name",
    },
    {
      field: "date_time",
      headerName: "Date / Time",
      render: (value) => formatDateTime(value),
    },
    { field: "weight", headerName: "Weight (KG)" },
    { field: "weight_change", headerName: "Weight Change (KG)" },
  ];

  return (
    <div>
      <TableComponent
        columns={columns}
        data={weights?.results || []}
        isLoading={isLoading}
        pagination={{ totalPages, currentPage }}
        onPageChange={handlePageChange}
        size="medium"
      />
    </div>
  );
};

export default WeightsContent;
